// global checkout event metric keys
export const PAYMENT_SECTION_SYSTEM_ERROR = 'error_co_payment_system'
const BACK_TO_SHOPPING_BAG_EVENT = 'back_to_shopping_bag'
const CLICK_CO_ADD_DISCOUNT = 'click_co_add_discount'
const SET_CUSTOMER_TYPE_EVENT = 'set_customer_type'
const SET_CUSTOMER_TYPE_ENTRY_EVENT = 'set_customer_type_entry'
const SET_ORDER_TYPE = 'set_order_type'
const SET_VISIT_CHECKOUT_EVENT = 'set_visit_checkout'
const CAPTURE_TIME_ON_PAGE_EVENT = 'capture_time_on_page'
const COMPLETE_PURCHASE_CLICK_EVENT = 'complete_purchase_click'
const MY_INFORMATION_SECTION_CTA_CLICK_AND_PROCEED = 'click_and_proceed_checkout_my_information_cta'
const DELIVERY_SECTION_CTA_CLICK_AND_PROCEED = 'click_and_proceed_checkout_delivery_cta'
const BILLING_SECTION_CTA_CLICK_AND_PROCEED = 'click_and_proceed_checkout_billing_cta'
const TAX_NUMBER_CHECKBOX_CLICK = 'click_tax_number_checkbox'
const TAX_NUMBER_INPUT_BLUR = 'blur_tax_number_input'
const VISIT_CHECKOUT_EVENT = 'cp_visit_checkout'
const REMOVE_ITEM_CHECKOUT_EVENT = 'remove_item_checkout'
const REMOVE_ITEM_CHECKOUT_MODAL_EVENT = 'remove_item_checkout_modal'
const THUMBNAIL_CLICK_CLOSE_EVENT = 'thumbnail_slider_close'
export const PAGEVIEW_CO_LOGIN = 'pageview_co_login'
export const LOGIN_FORGOT_PASSWORD = 'click_login_forgot_password'
export const ERROR_CO_LOGIN_BACKENDPWORD = 'error_co_login_backendpword'
export const LOGIN_CONTINUE_TO_CO_RETURNING = 'click_login_continue_to_co_returning'
export const LOGIN_CONTINUE_TO_CO_NEW = 'click_login_continue_to_co_new'
export const LOGIN_CONTINUE_TO_CO_GUEST = 'click_login_continue_to_co_guest'
export const ERROR_CO_PURCHASE_SYSTEM_BANK_TRANSFER = 'error_co_purchase_system_bank_transfer'
export const ERROR_CO_PURCHASE_SYSTEM = 'error_co_purchase_system'
export const CLICK_CO_USE_ANOTHER_EMAIL = 'click_co_use_another_email'
export const CLICK_CO_ALTERNATIVE_GUEST = 'click_co_alternative_guest'
export const CLICK_CO_LOGIN_SUBMIT_EMAIL = 'click_co_login_submit_email'
// Checkout address validation metric keys
export const MODAL_CO_ADDRESS_VALIDATION_SUGGEST = 'modal_co_address_validation_suggest'
export const CLICK_CO_ADDRESS_ACCEPT = 'click_co_address_accept'
export const CLICK_CO_ADDRESS_CONT_ANYWAY = 'click_co_address_cont_anyway'
export const MODAL_CO_ADDRESS_VALIDATION_ANY = 'modal_co_address_validation_any'
export const MODAL_CO_ADDRESS_VALIDATION_MULTI = 'modal_co_address_validation_multi'
export const MODAL_CO_ADDRESS_VALIDATION_SINGLE = 'modal_co_address_validation_single'
export const MODAL_CO_ADDRESS_VALIDATION_NONE = 'modal_co_address_validation_none'
export const CLICK_CO_ADDRESS_SHOW_MORE = 'click_co_address_show_more'
export const CLICK_CO_ADDRESS_EDIT = 'click_co_address_edit'
export const CLICK_CO_ADDRESS_NONE_ACCEPT = 'click_co_address_none_accept'
export const CLICK_CO_ADDRESS_NONE_EDIT = 'click_co_address_none_edit'
export const ERROR_CO_FIELD_ERRORS = 'error_co_field_errors'
export const BILLING_CHECKBOX_CLICK = 'billing_checkbox_click'

// global shopping bag event metric keys
const CLICK_SB_CONTINUE_TO_CO = 'click_sb_continue_to_co'
const CLICK_SB_REMOVE_ITEM = 'click_sb_remove_item'
const PAGEVIEW_SHOPPINGBAG = 'pageview_shoppingbag'
const ADD_VOUCHER = 'add_voucher'
const REDEEM_VOUCHER = 'redeem_voucher'
const CTA_REDEEM = 'cta_redeem'
const CTA_UNDO = 'cta_undo'
const ADD_VOUCHER_BANNER = 'add_voucher_banner'
const TOTAL_REDEEM = 'total_redeem'
const CLICK_SB_LOGIN_SIGNIN = 'click_sb_login_signin'
const CLICK_SB_ADD_TO_FAVOURITES = 'click_sb_add_to_favourites'
const CLICK_SB_ADD_DISCOUNT = 'click_sb_add_discount'
const VIEW_BANNER_REMINDER = 'View banner reminder'
const VIEW_BANNER = 'view_banner'
const WELCOME_OFFER_ADDED_TO_CART = 'Welcome_offer_added_to_cart'
const USED_DISCOUNT_CODE = 'used_discount_code'
const SHOPPINGBAG_INCREASE_PRODUCT_QUANTITY = 'shoppingbag_increase_product_quantity'
const SHOPPINGBAG_DECREASE_PRODUCT_QUANTITY = 'shoppingbag_decrease_product_quantity'
const SHOPPINGBAG_CLICK_RETURN_AND_REFUND_POLICY_CTA =
  'shoppingbag_click_return_and_refund_policy_cta'
const SHOPPINGBAG_CLICK_DELIVERY_AND_RETURNS_INFO_CTA =
  'shoppingbag_click_delivery_and_returns_info_cta'
const CAPTURE_TIME_ON_SB_PAGE = 'capture_time_on_sb_page'

// Member price in order totals
const MEMBER_PRICE_ORDER_TOTALS = 'crmro_member_price_order_totals'
const MEMBER_PRICE_APPLIED_VOUCHER_EXPERIMENT = 'crmro_member_price_applied_voucher'
const CLICK_ORDER_TOTALS_SIGNUP_BUTTON = 'click_order_totals_signup_button'
const CLICK_ORDER_TOTALS_SIGNUP_LINK = 'click_order_totals_signup_link'

// Digital Stylist metrics
const STEPS_COMPLETED_IN_DS_FEATURE = 'btso_steps_completed_in_ds'
const DS_QUIZ_COMPLETION_EVENT = 'btso_ds_quiz_completion'
const SHOW_PRODUCT_RECOMMENDATION_FEATURE = 'btso_ds_results_reco'
const DS_RECO_PRODUCT_CLICK_EVENT = 'btso_ds_results_reco_event'
const DS_SHOW_FAV_ICON = 'btso-addfavicon'
const DS_OMIT_OOS = 'btso-omitoos'

// My Closet
const MY_CLOSET_FLAG = 'btso-mycloset'
export const CLICK_MY_CLOSET_PRODUCTS = 'click_my_closet_products'
export const CLICK_MY_CLOSET_TAB = 'click_my_closet_tab'
export const CLOSET_OVERVIEW_PAGEVIEW = 'closet_overview_pageview'
export const CLOSET_DETAIL_PAGEVIEW = 'closet_detail_pageview'
export const CLOSET_OVERVIEW_EXIT_RATE = 'closet_overview_exit_rate'
export const CLOSET_DETAIL_EXITS = 'closet_detail_exits'
export const CLICK_MY_CLOSET_STYLE_IT = 'click_my_closet_style_it'
export const CLICK_MY_CLOSET_CARE_FOR_IT = 'click_my_closet_care_for_it'
export const CLICK_MY_CLOSET_BUY_IT_AGAIN = 'click_my_closet_buy_it_again'

// Styleboards
const STYLEBOARD_FLAG = 'crcom_styleboards_sweden_web'
const STYLEBOARD_SIMILAR_ITEMS_FLAG = 'bt_styleboards_similar_items'
const VIEW_STYLEBOARD_TAB_EVENT = 'view_styleboard_tab'
const VIEW_SIMILAR_ITEM_TAB_EVENT = 'view_similar_item_tab'
const ADD_ARTICLE_TO_STYLEBOARD_EVENT = 'add_article_to_styleboard'
const ADD_ARTICLE_TO_STYLEBOARD_FROM_SIMILAR_ITEMS_EVENT =
  'add_article_to_styleboard_from_similar_items'

// Section metrics
const EXPAND_EVENT_POSTFIX = '_section_expand'
const THUMBNAIL_CLICK_EVENT = 'thumbnail_click'
const CHOOSE_DISCOUNT_EVENT = 'choose_discount'
export const PARCEL_INFO_CLICK_EVENT = 'parcel_info_click'

// Features
const KLARNA_PAY_LATER = 'coweb_klarna_pay_later'
const ALWAYS_ALLOW_ORDER_SUBMIT_WITH_KLARNA = 'coweb_allow_klarna_order_submit'
const INSUFFICIENT_FUNDS = 'coweb_insufficient_funds_feature'
const CARDHOLDER_ADDRESS_FEATURE = 'cardholder_address'
export const PAY_LATER_GUEST_CHECKOUT_FEATURE = 'bnpl_pay_later_in_guest_co'
export const PAY_LATER_GUEST_CHECKOUT_UX_AB = 'bnpl_pay_later_in_gco_ux'
export const BNPL_PINK_LOGO_FEATURE = 'bnpl_pink_logo'
export const BNPL_PAY_KLARNA_ORDER_FROM_ONLINE_ORDER_DETAILS =
  'bnpl_pay_klarna_order_in_online_order_feature'
export const BANK_TRANSFER_WITH_PRESELECTED_BANK = 'bank_transfer_payment_method_feature'

// Pay Later Guest Checkout UX AB Events
export const CLICK_SUBMIT_MEMBER_FORM = 'click_co_save_member_form_gco_ab'
export const CLICK_EDIT_MEMBER_FORM = 'click_co_edit_member_form_gco_ab'

// Pay Later Guest Checkout Payment Errors AB
export const PAY_LATER_GUEST_CHECKOUT_PAYMENT_ERRORS_AB = 'bnpl_pay_later_in_gco_payment_errors'

// My Account
const ACCOUNT_MENU_CONFIGURATION_FEATURE = 'crmma_account_menu_configuration'
const ACCOUNT_DYNAMIC_USER_MENU = 'crmma_dynamic_user_menu'
const ACCOUNT_PAYMENTS_REACT = 'crmma_payments_react'
const ACCOUNT_ONLINE_STORE_ORDER = 'crmma_online_store_order'
const ACCOUNT_NEWS_WIDGET = 'crmma_news_widget'
const ACCOUNT_STYLE_YOUR_LATEST = 'crmma_style_your_latest_test'
const ACCOUNT_SWIPE_PROD_CAROUSEL = 'swipe_prod_carousel'
const ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE = 'click_prod_carousel_prod_image'
const ACCOUNT_CLICK_PROD_CAROUSEL = 'click_product_carousel'
const ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_1_2 = 'click_prod_carousel_prod_image_1_2'
const ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_3_4 = 'click_prod_carousel_prod_image_3_4'
const ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_5_6 = 'click_prod_carousel_prod_image_5_6'
const ACCOUNT_CLICK_ORDERED_ITEM = 'click_ordered_item'
const ACCOUNT_BACK_TO_PURCHASES = 'back_to_purchases'
const ACCOUNT_CLICK_SEARCH_SUBMIT = 'click_search_submit'
const ACCOUNT_CLICK_TRACK_ORDER = 'click_track_order'
const ACCOUNT_VISIT_ORDER_DETAIL_PAGE = 'visit_order_detail_page_account'
const ACCOUNT_STYLE_YOUR_LATEST_TOGGLE = 'crmma_style_your_latest_toggle'
const ACCOUNT_RESELL_SELLPY = 'crmma_resell_sellpy'
const ACCOUNT_RESELL_SELLPY_DISABLE_RATE_AND_REVIEW = 'crmma_resell_sellpy_disable_rate_and_review'
const ACCOUNT_CONFIGURED_OFFER_API_REDESIGN = 'crmma_configured_offer_api_redesign'
const ACCOUNT_USER_MENU_CTA_LINK = 'crmma_user_menu_cta_link'
const ACCOUNT_STATIC_MENU_ENABLE = 'crmma_static_menu_enable'
const ACCOUNT_EXTERNAL_COLLABORATION_ENABLE = 'crmma_external_collaboration_enable'
const ACCOUNT_ORDER_RETURN_CTA_SHIPPED_TOGGLE = 'crmma_enable_return_link_for_shipped_orders'
const ACCOUNT_CUSTOMER_SERVICE_BANNER_TOGGLE = 'crmma_customer_service_banner'
const ACCOUNT_PERSONAL_CONSENT = 'crmma_myaccount_korea_consent'
const ACCOUNT_HIDE_SMS_TEXT = 'crmma_hide_sms_text'
const ACCOUNT_HIDE_ORDER_STATUS_WIDGET = 'crmma_hide_order_status_widget'
const ACCOUNT_HIDE_ADDRESS = 'crmma_myaccount_serbia_edit_button'
const ACCOUNT_RATE_REVIEW = 'crmma_account_rate_review'
const ACCOUNT_LEGISLATION_PRICE = 'crmma_account_legislation_price'
const ACCOUNT_NEW_MEMBER_CARD = 'crmma_account_new_member_card'
const ACCOUNT_MEMBERSHIP_LINKS = 'crmma_account_membership_links'
const ACCOUNT_MEMBERSHIP_IMAGES = 'crmma_account_membership_images'
/**
 * This is a feature flag for Recently Viewed here is a link for more information:
 * https://hmgroup.atlassian.net/browse/CRMMA-5142
 */
const ACCOUNT_RECENTLY_VIEWED = 'crmma_account_recently_viwed'

/**
 * This is a feature flag for HelpUsImprove page here is a link for more information:
 * https://hmgroup.atlassian.net/browse/CRMMA-5292
 */
const ACCOUNT_HELP_US_IMPROVE = 'crmma_account_help_us_improve'

/* This is a feature flag for new vouchers and offers section in my account page and here is a link for more information:
 * https://hmgroup.atlassian.net/browse/CRMMA-4742
 */
const ACCOUNT_NEW_VOUCHERS_OFFERS = 'crmma_account_new_vouchers_offers'

/* This is a feature flag for detailed consignment tracking in my account page and here is a link for more information:
 * https://hmgroup.atlassian.net/browse/CRMMA-4719
 */
const ACCOUNT_CONSIGMENT_TRACKING = 'crmma_consignment_tracking'

/* This is a feature flag to hide the text underneath barcode for Poland market as the translation is coming wrong from Smartlink
 * https://hmgroup.atlassian.net/browse/CRMMA-6349
 */
const ACCOUNT_HIDE_BARCODE_TEXT = 'crmma_hide_barcode_text'

/* This is a feature flag for detailed consignment tracking in my account page and here is a link for more information:
 * https://hmgroup.atlassian.net/browse/CRMMA-5948
 */
const ACCOUNT_DISABLED_AUTO_SUGGESTION = 'crmma_disable_auto_suggestion'

// MyAccount Menu Subtext and new tag experiment
const ACCOUNT_MENU_SUBTEXT_NEWTAG = 'crmma_menu_subtext_newtag'
const ACCOUNT_ORDER_DETAILS_MENU = 'click_my_account_order_details'
const ACCOUNT_PAYMENTS_MENU = 'click_my_account_payments'
const ACCOUNT_SETTINGS_MENU = 'click_my_account_account_settings'
const ACCOUNT_POINTS_HISTORY_MENU = 'click_my_account_points_history'
const ACCOUNT_MEMBERSHIP_MENU = 'click_my_account_membership'
const ACCOUNT_CUSTOMER_SERVICE_MENU = 'click_my_account_customer_service'
const ACCOUNT_RATE_AND_REVIEW_MENU = 'click_my_account_rate_review'
const ACCOUNT_HELP_US_IMPROVE_MENU = 'click_my_account_help_us_improve'
const ACCOUNT_INVITE_A_FRIEND_MENU = 'click_my_account_invite_a_friend'
const ACCOUNT_TIME_TAKEN_TO_HELP_US_IMPROVE = 'time_taken_to_Help_Us_Improve'
const ACCOUNT_TIME_TAKEN_TO_INVITE_A_FRIEND = 'time_taken_to_Invite_a_Friend'
const ACCOUNT_MENU_OPTIONS = 'click_my_account_menu_options'
const ACCOUNT_PAYMENT_KLARNA_MENU = 'click_my_account_payment_klarna'
const ACCOUNT_HUI_SUBMIT = 'click_my_account_hui_submit'
const ACCOUNT_IAF_COPY_LINK = 'click_my_account_iaf_copylink'
const ACCOUNT_HIDE_DEFAULT_ADDRESS_CHECKBOX = 'crmma_hide_default_address_checkbox'
// This is feature toggle to handle exception scenario for Serbia market
const ACCOUNT_POSTAL_CODE = 'crmma_myaccount_serbia_postal_code_input'

// This is MyAccount experiment for Northstar
const ACCOUNT_NORTHSTAR_VARIATION = 'myaccount_northstar_variaton'
const ACCOUNT_LANDING_PAGE_VIEW = 'pageviews_myaccount_landing_page'
const ACCOUNT_VIEW_REWARD_MEMBERSHIP = 'click_on_view_reward_membership_carousel'
const ACCOUNT_VIEW_ALL_BUTTON = 'click_viewall_button_on_offer_or_voucher_carousel'
const ACCOUNT_ORDER_BOTTOM_MENU = 'click_orderlist_bottommenu'
const ACCOUNT_POINTS_HISTORY_BOTTOM_MENU = 'click_points_history_bottom_menu'
const ACCOUNT_SETTINGS_BOTTOM_MENU = 'click_settings_bottommenu'
const ACCOUNT_MEMBER_INFO_BOTTOM_MENU = 'click_memberinfo_bottommenu'
const ACCOUNT_CUSTOMER_SERVICE_BOTTOM_MENU = 'click_customer_service_button'
const ACCOUNT_SIGN_OUT_BOTTOM_MENU = 'click_signout_bottommenu'
const ACCOUNT_REWARD_VIEWALL_PAGEVIEW = 'pageviews_viewall_reward_page'
const ACCOUNT_REWARD_DETAIL_PAGEVIEW = 'pageviews_reward_detail_page'
const ACCOUNT_BUTTON_REWARD_DETAIL_PAGE = 'cta_button_on_reward_detail_page'
const ACCOUNT_LINK_REWARD_DETAIL_PAGE = 'cta_link_on_reward_detail_page'
const ACCOUNT_ORDER_CLICK = 'click_on_order_from_orderlist_page'
const ACCOUNT_ORDER_LIST_PAGEVIEW = 'pageviews_order_list_page'
const ACCOUNT_ORDER_DETAILS_PAGE_VIEW = 'pageviews_order_details_page'
const ACCOUNT_ORDER_CLICK_LANDING_PAGE = 'click_on_online_purchases_landing_page'
const ACCOUNT_CUSTOMER_SERVICE_CLICK_ON_ORDER_DETAIL = 'click_customer_service_order_details_page'

// Donate voucher experiment
const DONATE_VOUCHER = 'crmen_donate_voucher'
const DONATE_VOUCHER_EXPERIMENT = 'crmen_donate_voucher_experiment'
const CLICK_DONATE_VOUCHER_TEASER = 'click_donate_voucher_teaser'
const CLICK_DONATE_VOUCHER_MENU = 'click_donate_voucher_menu'
const CLICK_DONATE_VOUCHER_VOUCHER = 'click_donate_voucher_voucher'
const CLICK_ATB_REWARDS_PAGE = 'click_atb_rewards_page'
const CLICK_DONATE_VOUCHER_TOP_OF_MENU = 'click_donate_voucher_top_of_menu'
const CLICK_SURVEY_SUBMIT = 'click_survey_submit'
const CLICK_SURVEY_CANCEL = 'click_survey_cancel'
const CLICK_SURVEY_CLOSE = 'click_survey_close'
const CLICK_ANY_INFO_TYPE_REWARDS_MY_ACCOUNT = 'click_any_info_type_rewards_my_account'
const CLICK_REDEEM_IN_STORE = 'click_redeem_in_store'
const CLICK_POINTS_HISTORY_ENTRANCE = 'click_points_history_entrance'
const CLICK_POINT_HISTORY_ENTRANCE = 'click_point_history_entrance'

// GENERIC
const GENERIC_FLAG_TOGGLE_OFF = 'off'

// CO Delivery Speed Variation
const ALTERNATE_DELIVERY_TIME_TEXT = 'coweb_alternate_delivery_time_text'

// My Account Fashion News Banner Campaign
const LCA_FASHION_NEWS_CAMPAIGN_BANNER = 'lca_fashion_news_campaign_banner'
const LCA_FASHION_NEWS_CAMPAIGN_BANNER_DOUBLE_OPT_IN =
  'lca_fashion_news_campaign_banner_double_opt_in'

const LCA_FASHION_NEWS_CAMPAIGN_RESEND_DOUBLE_OPTIN =
  'lca_fashion_news_campaign_resend_double_opt_in'

const LCA_FASHION_NEWS_NO_OFFER_CAMPAIGN_BANNER = 'lca_fashion_news_no_offer_campaign_banner'

const LCA_FASHION_WELCOME_OFFER_LOGIN_BANNER = 'lca_welcome_offer_login_banner'
const LCA_FASHION_WELCOME_OFFER_NO_LOGIN_BANNER = 'lca_welcome_offer_no_login_banner'
const LCA_WELCOME_OFFER_FEATURE = 'lca_welcome_offer_feature'
const LCA_VOUCHER_SHOPPING_BAG = 'lca_voucher_shopping_bag'
const LCA_MULTI_CLICK_BANNER = 'lca_multi_click_banner'

const CLICK_FN_NO_OFFER_BANNER_CTA = 'click_fn_no_offer_banner_cta'
const CAMPAIGN_NO_OFFER_BANNER_FN_SUBSCRIBER = 'campaign_no_offer_banner_fn_subscriber'

// Gamification
const GAMIFICATION_CHALLENGES = 'lca_gamification_challenges'
const VIEW_ENTRY_POINT_BANNER = 'view_entry_point_banner'
const CLICK_ENTRY_POINT_BANNER = 'click_entry_point_banner'
const VIEW_CHALLENGES_PAGE = 'view_challenges_page'
const CLICK_FAVOURITE_CHALLENGES_CARD = 'click_favourite_challenges_card'
const CLICK_RECYCLING_CHALLENGES_CARD = 'click_recycling_challenges_card'
const CLICK_COLLECT_POINT_CHALLENGES_CARD = 'click_collect_point_challenges_card'
const CLICK_SCAN_BARCODE_CHALLENGES_CARD = 'click_scan_barcode_challenges_card'
const CLICK_IMAGE_SEARCH_CHALLENGES_CARD = 'click_image_search_challenges_card'
const CLICK_STYLEBOARD_CHALLENGES_CARD = 'click_styleboard_challenges_card'

// Digital store layer

const INCREASED_SEARCHED_RADIUS = 'btbpsdl_inreased_search_radius'

// Expand payment section for customers with banktransfer and no selected option
export const COWEB_EXPAND_PAYMENT_SECTION_WHEN_BANK_TRANSFER_SELECTED =
  'coweb_expand_payment_section_when_bank_transfer_selected'
export const SHOULD_EXPAND_PAYMENT_SECTION = 'should_expand_payment_section'

// Points History Page
const LCA_FN_SUBSCRIPTION_IN_PHP = 'lca_fn_subscription_in_php'
const VIEW_FN_SUBSCRIBE_PHP_BANNER = 'view_fn_subscribe_php_banner'
const CLICK_FN_THANK_YOU_PHP_ACCOUNT_LINK = 'click_fn_thank_you_php_account_link'
const CLICK_FN_SUBSCRIBE_PHP_PRIVACY_LINK = 'click_fn_subscribe_php_privacy_link'
const VIEW_FN_THANK_YOU_PHP_BANNER = 'view_fn_thank_you_php_banner'
const CLICK_FN_SUBSCRIBE_PHP_BUTTON = 'click_fn_subscribe_php_button'
const CLICK_SUBSCRIBE_FN_SAVE_BUTTON = 'click_subscribe_fn_save_button'
const CLICK_UNSUBSCRIBE_FN_SAVE_BUTTON = 'click_unsubscribe_fn_save_button'

// CPO Display save cards disabled due to new mandate in India message
export const CPO_INDIA_SAVE_CARDS_DISABLED_MESSAGE = 'cpo_india_save_cards_disabled_message'
export const CPO_SAVE_CARDS_DISABLED_MESSAGE = 'save_cards_disabled_message'

// The new version of account/points-history page. The toggle will stay until we switch completely to the new version and remove the legacy one.
export const POINTS_HISTORY_NEW_API = 'points_history_new_api'

// BTSH - Favourites image experiments
export const FAVOURITES_IMAGE_EXPERIMENT = 'btsh_hover_favourites_image_experiment'
export const BTSH_CLICK_FAVOURITES_PRODUCT_LINK = 'btsh_click_favourites_product_link'

// Digital Returns new in-house feature
export const DIGITAL_RETURNS_FEATURE = 'dr_digital_returns'

// Stylestories
export const CLICK_LANDING_PAGE_STYLESTORY = 'stylestory_click_landing_page'
export const CLICK_LANDING_PAGE_ANYCONTENT = 'click_landing_page'
export const CLICK_LANDING_PAGE_STYLEBOARD = 'styleboard_click_landing_page'
export const CLICK_LOAD_MORE_STYLESTORY = 'stylestory_landing_page_load_more'
export const CLICK_LOAD_MORE_ANYPAGE = 'stylestory_both_page_load_more'
export const CLICK_LOAD_MORE_COMBINED = 'combined_landing_page_load_more'
export const VIEW_LOAD_MORE_STYLESTORY = 'stylestory_landing_page_view_load_more'
export const CLICK_LANDING_PAGE_USERNAME = 'stylestory_click_landing_page_username'
export const CLICK_GET_THE_LOOK_IMAGE = 'stylestory_click_get_the_look_image'
export const CLICK_GET_THE_LOOK_PRODUCT = 'stylestory_click_get_the_look_product'
export const CLICK_GET_THE_LOOK_CTA = 'stylestory_click_get_the_look_cta'
export const CLICK_BACK_TO_TOP = 'stylestory_click_back_to_top'
export const CLICK_BACK_TO_START = 'stylestory_click_back_to_start'
export const PAGEVIEW_STYLESTORY = 'pageview_stylestory_landing_page'
export const PAGEVIEW_STYLEBOARD = 'pageview_combined_landing_page'
export const STYLESTORY_VIEW = 'stylestories_view'
export const STYLEBOARD_VIEW = 'styleboards_view'
const STYLESTORIES_COMBINED_LANDING_PAGE = 'stylestories_mobileweb_se'

// COWEB Combine MyInfo and Billing experiment
export const COWEB_COMBINE_MYINFO_AND_BILLING_SECTION = 'coweb_combine_myinfo_and_billing_section'
export const SHOULD_COMBINE_SECTIONS = 'should_combine_sections'

// COWEB India Market Payment Error
export const COWEB_PAYMENT_ERROR_IN = 'coweb_rupay_error'

// COPAYNOL Razorpay payment options
export const COPAYNOL_INDIA_PAYMENT_METHOD_OPTIONS = 'copaynol_india_payment_method_options'
export const SHOULD_SHOW_ALL_INDIA_PAYMENT_METHOD_OPTIONS =
  'should_show_all_india_payment_method_options'
export const SHOULD_SHOW_RAZORPAY_BASELINE = 'should_show_razorpay_baseline'
export const SHOULD_SHOW_GENERAL_RAZORPAY_CHECKOUT_OPTION =
  'should_show_general_razorpay_checkout_option'
export const SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS = 'should_show_all_razorpay_checkout_options'
export const SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS_WITH_SUBMETHOD =
  'should_show_all_razorpay_checkout_options_with_submethod'

// COCPO Credit Guard integration testing
export const COCPO_ISRAEL_PAYMENT_INTEGRATION = 'cocpo_il_payment_integration'

// COWEB New User Login Flow UI Update
export const COWEB_NEW_USER_LOGIN_FLOW_UI_UPDATE = 'coweb_new_user_login_flow_ui_update'
export const SHOULD_SHOW_UPDATED_LOGIN_FLOW_UI = 'should_show_updated_login_flow_ui'
export const SHOULD_SHOW_UPDATED_UI_OLD_LABELS = 'should_show_updated_ui_old_labels'

// COPAYNOL Open payment methods section for Paypal returning customers
export const COPAYNOL_EXPAND_PAYMENT_METHODS_FOR_PAYPAL_RETURNING_CUSTOMERS =
  'copaynol_expand_payment_methods_for_paypal_returning_customers'

// COWEB Single Parcel as Multiple Parcel Design
export const COWEB_SINGLE_PARCEL_AS_MULTIPLE_PARCEL_DESIGN =
  'coweb_single_parcel_as_multiple_parcel_design'
export const SHOULD_SHOW_MP_DESIGN_AND_HIDE_ADDRESS = 'should_show_mp_design_and_hide_address'
export const SHOULD_SHOW_MULTIPLE_PARCEL_DESIGN = 'should_show_multiple_parcel_design'

// COWEB Disaster Flag, used to show emergency messaging in CO
export const COWEB_DISASTER_FLAG = 'coweb_disaster_flag'

// COWEB Informatica Address Suggestions
export const COWEB_INFORMATICA_ADDRESS_SUGGESTIONS = 'coweb_informatica_address_suggestions'
export const SHOULD_USE_INFORMATICA_ADDRESS_SUGGESTIONS =
  'should_use_informatica_address_suggestions'
export const CLICK_CO_ADDRESS_AUTOCOMPLETE_FILL = 'click_co_address_autocomplete_fill'

// COWEB Nordics Delivery Reconsideration
export const COWEB_NORDICS_DELIVERY_RECONSIDERATION = 'coweb_nordics_delivery_reconsideration'
export const SHOULD_LET_USER_RECONSIDER_DELIVERY = 'should_let_user_reconsider_delivery'

// COWEB Save Submitted Address For Editing
export const COWEB_SAVE_SUBMITTED_ADDRESS_FOR_EDITING = 'coweb_save_submitted_address_for_editing'
export const SHOULD_SHOW_ADDRESS_FROM_ADDRESS_SUGGESTIONS =
  'should_show_address_from_address_suggestions'

// COWEB Expandable Field Copy Change
export const COWEB_EXPANDABLE_FIELD_COPY_CHANGE = 'coweb_expandable_field_copy_change'
export const SHOULD_UPDATE_COPY = 'should_update_copy'
export const CLICK_CO_ADDITIONAL_ADDRESS_INFO = 'click_co_additional_address_info'

// EWVA Deal Communication SB
const EWVA_SB_MESSAGES = 'ewva_sb_messages'

export default {
  DIGITAL_RETURNS_FEATURE,
  VISIT_CHECKOUT_EVENT,
  SET_VISIT_CHECKOUT_EVENT,
  BACK_TO_SHOPPING_BAG_EVENT,
  CLICK_CO_ADD_DISCOUNT,
  SET_CUSTOMER_TYPE_EVENT,
  SET_CUSTOMER_TYPE_ENTRY_EVENT,
  SET_ORDER_TYPE,
  STEPS_COMPLETED_IN_DS_FEATURE,
  SHOW_PRODUCT_RECOMMENDATION_FEATURE,
  DS_RECO_PRODUCT_CLICK_EVENT,
  DS_QUIZ_COMPLETION_EVENT,
  DS_SHOW_FAV_ICON,
  DS_OMIT_OOS,
  MY_CLOSET_FLAG,
  STYLEBOARD_FLAG,
  STYLEBOARD_SIMILAR_ITEMS_FLAG,
  VIEW_STYLEBOARD_TAB_EVENT,
  VIEW_SIMILAR_ITEM_TAB_EVENT,
  ADD_ARTICLE_TO_STYLEBOARD_EVENT,
  ADD_ARTICLE_TO_STYLEBOARD_FROM_SIMILAR_ITEMS_EVENT,
  CAPTURE_TIME_ON_PAGE_EVENT,
  EXPAND_EVENT_POSTFIX,
  THUMBNAIL_CLICK_EVENT,
  COMPLETE_PURCHASE_CLICK_EVENT,
  CARDHOLDER_ADDRESS_FEATURE,
  ACCOUNT_MENU_CONFIGURATION_FEATURE,
  ACCOUNT_DYNAMIC_USER_MENU,
  ACCOUNT_PAYMENTS_REACT,
  ACCOUNT_ONLINE_STORE_ORDER,
  ACCOUNT_NEWS_WIDGET,
  ACCOUNT_CONSIGMENT_TRACKING,
  ACCOUNT_STYLE_YOUR_LATEST,
  ACCOUNT_SWIPE_PROD_CAROUSEL,
  ACCOUNT_CLICK_PROD_CAROUSEL,
  ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE,
  ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_1_2,
  ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_3_4,
  ACCOUNT_CLICK_PROD_CAROUSEL_PROD_IMAGE_5_6,
  ACCOUNT_CLICK_ORDERED_ITEM,
  ACCOUNT_BACK_TO_PURCHASES,
  ACCOUNT_CLICK_SEARCH_SUBMIT,
  ACCOUNT_CLICK_TRACK_ORDER,
  ACCOUNT_VISIT_ORDER_DETAIL_PAGE,
  ACCOUNT_STYLE_YOUR_LATEST_TOGGLE,
  ACCOUNT_RESELL_SELLPY,
  ACCOUNT_RESELL_SELLPY_DISABLE_RATE_AND_REVIEW,
  ACCOUNT_ORDER_RETURN_CTA_SHIPPED_TOGGLE,
  ACCOUNT_CUSTOMER_SERVICE_BANNER_TOGGLE,
  ACCOUNT_HELP_US_IMPROVE,
  ACCOUNT_HIDE_SMS_TEXT,
  ACCOUNT_HIDE_ORDER_STATUS_WIDGET,
  ACCOUNT_HIDE_BARCODE_TEXT,
  ACCOUNT_HIDE_DEFAULT_ADDRESS_CHECKBOX,
  MY_INFORMATION_SECTION_CTA_CLICK_AND_PROCEED,
  CHOOSE_DISCOUNT_EVENT,
  DONATE_VOUCHER,
  DONATE_VOUCHER_EXPERIMENT,
  CLICK_DONATE_VOUCHER_TEASER,
  CLICK_DONATE_VOUCHER_MENU,
  CLICK_DONATE_VOUCHER_VOUCHER,
  CLICK_ATB_REWARDS_PAGE,
  CLICK_DONATE_VOUCHER_TOP_OF_MENU,
  CLICK_SURVEY_SUBMIT,
  CLICK_SURVEY_CANCEL,
  CLICK_SURVEY_CLOSE,
  CLICK_ANY_INFO_TYPE_REWARDS_MY_ACCOUNT,
  CLICK_REDEEM_IN_STORE,
  CLICK_POINTS_HISTORY_ENTRANCE,
  CLICK_POINT_HISTORY_ENTRANCE,
  CLICK_SB_CONTINUE_TO_CO,
  CLICK_SB_REMOVE_ITEM,
  CLICK_SB_ADD_DISCOUNT,
  USED_DISCOUNT_CODE,
  PAGEVIEW_SHOPPINGBAG,
  ADD_VOUCHER,
  KLARNA_PAY_LATER,
  REDEEM_VOUCHER,
  CLICK_SB_LOGIN_SIGNIN,
  CLICK_SB_ADD_TO_FAVOURITES,
  VIEW_BANNER_REMINDER,
  SHOPPINGBAG_INCREASE_PRODUCT_QUANTITY,
  SHOPPINGBAG_DECREASE_PRODUCT_QUANTITY,
  SHOPPINGBAG_CLICK_RETURN_AND_REFUND_POLICY_CTA,
  SHOPPINGBAG_CLICK_DELIVERY_AND_RETURNS_INFO_CTA,
  CAPTURE_TIME_ON_SB_PAGE,
  MEMBER_PRICE_ORDER_TOTALS,
  CLICK_ORDER_TOTALS_SIGNUP_BUTTON,
  CLICK_ORDER_TOTALS_SIGNUP_LINK,
  GENERIC_FLAG_TOGGLE_OFF,
  TAX_NUMBER_CHECKBOX_CLICK,
  TAX_NUMBER_INPUT_BLUR,
  INSUFFICIENT_FUNDS,
  LCA_FASHION_NEWS_CAMPAIGN_BANNER,
  LCA_FASHION_NEWS_CAMPAIGN_BANNER_DOUBLE_OPT_IN,
  LCA_FASHION_NEWS_CAMPAIGN_RESEND_DOUBLE_OPTIN,
  LCA_FASHION_NEWS_NO_OFFER_CAMPAIGN_BANNER,
  LCA_FASHION_WELCOME_OFFER_NO_LOGIN_BANNER,
  LCA_FASHION_WELCOME_OFFER_LOGIN_BANNER,
  DELIVERY_SECTION_CTA_CLICK_AND_PROCEED,
  BILLING_SECTION_CTA_CLICK_AND_PROCEED,
  ALTERNATE_DELIVERY_TIME_TEXT,
  ALWAYS_ALLOW_ORDER_SUBMIT_WITH_KLARNA,
  ACCOUNT_CONFIGURED_OFFER_API_REDESIGN,
  ACCOUNT_USER_MENU_CTA_LINK,
  ACCOUNT_STATIC_MENU_ENABLE,
  ACCOUNT_EXTERNAL_COLLABORATION_ENABLE,
  CLICK_FN_NO_OFFER_BANNER_CTA,
  CAMPAIGN_NO_OFFER_BANNER_FN_SUBSCRIBER,
  MEMBER_PRICE_APPLIED_VOUCHER_EXPERIMENT,
  INCREASED_SEARCHED_RADIUS,
  REMOVE_ITEM_CHECKOUT_EVENT,
  REMOVE_ITEM_CHECKOUT_MODAL_EVENT,
  THUMBNAIL_CLICK_CLOSE_EVENT,
  ACCOUNT_PERSONAL_CONSENT,
  POINTS_HISTORY_NEW_API,
  GAMIFICATION_CHALLENGES,
  VIEW_ENTRY_POINT_BANNER,
  CLICK_FAVOURITE_CHALLENGES_CARD,
  CLICK_RECYCLING_CHALLENGES_CARD,
  CLICK_COLLECT_POINT_CHALLENGES_CARD,
  CLICK_SCAN_BARCODE_CHALLENGES_CARD,
  CLICK_IMAGE_SEARCH_CHALLENGES_CARD,
  CLICK_STYLEBOARD_CHALLENGES_CARD,
  CLICK_ENTRY_POINT_BANNER,
  VIEW_CHALLENGES_PAGE,
  LCA_FN_SUBSCRIPTION_IN_PHP,
  ACCOUNT_NEW_VOUCHERS_OFFERS,
  ACCOUNT_RECENTLY_VIEWED,
  VIEW_FN_SUBSCRIBE_PHP_BANNER,
  CLICK_FN_THANK_YOU_PHP_ACCOUNT_LINK,
  CLICK_FN_SUBSCRIBE_PHP_PRIVACY_LINK,
  VIEW_FN_THANK_YOU_PHP_BANNER,
  CLICK_FN_SUBSCRIBE_PHP_BUTTON,
  CLICK_SUBSCRIBE_FN_SAVE_BUTTON,
  CLICK_UNSUBSCRIBE_FN_SAVE_BUTTON,
  LCA_WELCOME_OFFER_FEATURE,
  ACCOUNT_HIDE_ADDRESS,
  ACCOUNT_MENU_SUBTEXT_NEWTAG,
  ACCOUNT_ORDER_DETAILS_MENU,
  ACCOUNT_PAYMENTS_MENU,
  ACCOUNT_SETTINGS_MENU,
  ACCOUNT_POINTS_HISTORY_MENU,
  ACCOUNT_MEMBERSHIP_MENU,
  ACCOUNT_CUSTOMER_SERVICE_MENU,
  ACCOUNT_RATE_AND_REVIEW_MENU,
  ACCOUNT_HELP_US_IMPROVE_MENU,
  ACCOUNT_INVITE_A_FRIEND_MENU,
  ACCOUNT_TIME_TAKEN_TO_HELP_US_IMPROVE,
  ACCOUNT_PAYMENT_KLARNA_MENU,
  ACCOUNT_TIME_TAKEN_TO_INVITE_A_FRIEND,
  ACCOUNT_RATE_REVIEW,
  ACCOUNT_MENU_OPTIONS,
  ACCOUNT_HUI_SUBMIT,
  ACCOUNT_IAF_COPY_LINK,
  ACCOUNT_POSTAL_CODE,
  LCA_VOUCHER_SHOPPING_BAG,
  LCA_MULTI_CLICK_BANNER,
  ACCOUNT_LEGISLATION_PRICE,
  ACCOUNT_NEW_MEMBER_CARD,
  ACCOUNT_MEMBERSHIP_LINKS,
  ACCOUNT_NORTHSTAR_VARIATION,
  ACCOUNT_MEMBERSHIP_IMAGES,
  ACCOUNT_LANDING_PAGE_VIEW,
  ACCOUNT_VIEW_REWARD_MEMBERSHIP,
  ACCOUNT_VIEW_ALL_BUTTON,
  ACCOUNT_ORDER_BOTTOM_MENU,
  ACCOUNT_POINTS_HISTORY_BOTTOM_MENU,
  ACCOUNT_SETTINGS_BOTTOM_MENU,
  ACCOUNT_MEMBER_INFO_BOTTOM_MENU,
  ACCOUNT_CUSTOMER_SERVICE_BOTTOM_MENU,
  ACCOUNT_SIGN_OUT_BOTTOM_MENU,
  ACCOUNT_REWARD_VIEWALL_PAGEVIEW,
  ACCOUNT_REWARD_DETAIL_PAGEVIEW,
  ACCOUNT_BUTTON_REWARD_DETAIL_PAGE,
  ACCOUNT_LINK_REWARD_DETAIL_PAGE,
  ACCOUNT_ORDER_CLICK,
  ACCOUNT_ORDER_LIST_PAGEVIEW,
  ACCOUNT_ORDER_DETAILS_PAGE_VIEW,
  ACCOUNT_ORDER_CLICK_LANDING_PAGE,
  ACCOUNT_CUSTOMER_SERVICE_CLICK_ON_ORDER_DETAIL,
  CTA_REDEEM,
  CTA_UNDO,
  ADD_VOUCHER_BANNER,
  TOTAL_REDEEM,
  STYLESTORIES_COMBINED_LANDING_PAGE,
  ACCOUNT_DISABLED_AUTO_SUGGESTION,
  VIEW_BANNER,
  WELCOME_OFFER_ADDED_TO_CART,
  EWVA_SB_MESSAGES,
}
